import momentJalaali from "moment-jalali";
import Loader from "react-loader-spinner";
import { useDispatch } from "react-redux";
import { Fragment, useEffect, useState } from "react";
import icons8 from "../../content/images/icons8-go-back-24.png";
import backWhite from "../../content/images/icons8-go-back-White.png";
import "../../Css/Stimulsoft/stimulsoft.viewer.office2013.lightgrayblue.css";
import "../../Css/Stimulsoft/stimulsoft.designer.office2013.lightgrayblue.css";
import { savePrintReport, loadPrintDataSource_get, loadPrintDataSource_post, setErrorDialog, sleep, loadPrintReportAsync, loadPrintDataSource_getAsync, loadPrintDataSource_postAsync } from "../../store/api/CommonFunctions";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint, faTimes } from "@fortawesome/free-solid-svg-icons";

/**
 * @component
 * @param {object} props
 * @param {string} props.reportName
 * @param {JSON} props.fetchBody
 * @param {string} props.dataUrl
 * @param {"get" |"post"} props.method
 * @param {string} props.serverUrl
 * @param {JSON} props.jsonObject
 * @param {object} props.modalData
 * @param {string} props.modalData.reportName
 * @param {"true"|"false"} props.modalData.show
 * @param {string} props.modalData.title
 * @returns 
 */
export default function ModalPrintViewer({ fetchBody, dataUrl, method, serverUrl, jsonObject, modalData, setModalData }) {

    const [loaded, setLoaded] = useState(true);
    const dispatch = useDispatch();
    const [pending, setPending] = useState(false);
    const { reportName, show, title, onPrint } = modalData;
    const designMode = modalData?.designMode ?? false;
    const company = JSON.parse(localStorage.getItem("Company"));
    const report = new window.Stimulsoft.Report.StiReport();
    report.info.zoom = 0.9;


    function addOrUpdateVariable(name, title, value) {
        let variable = report.dictionary.variables.getByName(name);
        if (!variable) {
            variable = new window.Stimulsoft.Report.Dictionary.StiVariable();
            variable.name = name;
            variable.alias = title;
            variable.Type = window.Stimulsoft.System.StimulsoftType;
            variable.requestFromUser = false;
            report.dictionary.variables.add(variable);
        }
        variable.value = value;
        
    }
    async function setReportData(jsonData) {

        addOrUpdateVariable("CurrentDate", "تاریخ امروز", momentJalaali().format('jYYYY/jM/jD'));
        addOrUpdateVariable("CompanyAddress", "آدرس شرکت", company?.CompanyAddress);
        addOrUpdateVariable("CompanyName", "نام شرکت", company?.CompanyName);
        addOrUpdateVariable("CompanyPhone", "تلفن شرکت", company?.Phone);

        const dataSet = new window.Stimulsoft.System.Data.DataSet("ds" + reportName);

        if (!window.Stimulsoft.Report.Dictionary.StiFunctions.functions.keys.includes("ModifyDigits")) {
            const fnModifyDigits = (value) => {
                if (value) {
                    return value.replaceAll("٤", "۴").replaceAll("٥", "۵").replaceAll("٦", "۶")
                }
                else {
                    return "";
                }
            }

            window.Stimulsoft.Report.Dictionary.StiFunctions
                .addFunction("Strings",
                    "ModifyDigits",
                    "ModifyDigits",
                    "تبدیل اعداد عربی به فارسی",
                    "",
                    String,
                    "فارسی شده اعداد عربی",
                    [String],
                    ["value"],
                    ["Descriptions"],
                    fnModifyDigits)

        }
        let ds = jsonData;
        if (ds?.Data) {
            ds = ds.Data;
        }
        dataSet.readJson(JSON.stringify(ds));
        report.regData("ds" + reportName, "ds" + reportName, dataSet);
        if (fetchBody) {
            const dataSetFilters = new window.Stimulsoft.System.Data.DataSet("dsFilters");
            dataSetFilters.readJson(fetchBody);
            if (dataSetFilters.tables.list[0]) {
                dataSetFilters.tables.list[0]._tableName = "tblFilters";
            }
            report.regData("dsFilters", "dsFilters", dataSetFilters);
        }
        report.dictionary.synchronize();
        setPending(false);
        report.reportAlias = reportName;
        const viewMode = !(JSON.parse(designMode));
        if (viewMode) {
            const viewOptions = new window.Stimulsoft.Viewer.StiViewerOptions();
            viewOptions.appearance.fullScreenMode = true;
            viewOptions.appearance.scrollbarsMode = true;
            viewOptions.toolbar.showViewModeButton = true;
            viewOptions.toolbar.printDestination = window.Stimulsoft.Viewer.StiPrintDestination.Direct;
            const viewer = new window.Stimulsoft.Viewer.StiViewer(viewOptions, "StiViewer", false);
            viewer.report = report;
            viewer.renderHtml("printDesigner");
            viewer.onPrintReport = function (event) {
                if (typeof (onPrint) === "function") {
                    try {
                        onPrint();
                    }
                    catch (ex) { setErrorDialog(dispatch, "اشکال در عملیات چاپ", title ?? "چاپ") }
                }
            }
            var userButton = viewer.jsObject.SmallButton("userButton", "بازگشت", "emptyImage");
            userButton.style["font-family"] = "Vazir";
            userButton.style["color"] = "blue";
            userButton.image.src = icons8;
            userButton.action = function () { setModalData({ show: false }) }

            var toolbarTable = viewer.jsObject.controls.toolbar.firstChild.firstChild;
            var buttonsTable = toolbarTable.rows[0].firstChild.firstChild;
            var userButtonCell = buttonsTable.rows[0].insertCell(0);
            userButtonCell.className = "stiJsViewerClearAllStyles";
            userButtonCell.appendChild(userButton);
        }
        else if (!viewMode) {
            const options = new window.Stimulsoft.Designer.StiDesignerOptions();
            options.appearance.fullScreenMode = true;
            options.appearance.htmlRenderMode = window.Stimulsoft.Report.Export.StiHtmlExportMode.Div;
            const designer = new window.Stimulsoft.Designer.StiDesigner(options, "Designer", false);
            designer.onSaveReport = function (e) {
                const jsonStr = e.report.saveToJsonString();
                savePrintReport(reportName, jsonStr);
            }
            designer.onSaveAsReport = (e) => {
                e.fileName = "Letter_" + e.fileName;
                e.report.reportName = e.fileName;
                e.report.reportAlias = e.fileName;
                const jsonStr = e.report.saveToJsonString();
                savePrintReport(e.fileName, jsonStr);
            }
            designer.report = report;
            designer.renderHtml("printDesigner");
            designer.jsObject.options.images["ImageBack"] = backWhite;
            var toolBarRow = designer.jsObject.options.toolBar.firstChild.tr[0];
            var customButton = designer.jsObject.StatusPanelButton("btnBack", "بازگشت", "ImageBack", null, null, 30, 30);
            customButton.action = function () { setModalData({ show: false }) }
            customButton.style["font-family"] = "Vazir";
            customButton.style["color"] = "white";
            var buttonCell = document.createElement("td");
            buttonCell.className = "stiDesignerToolButtonCell";
            buttonCell.appendChild(customButton);
            toolBarRow.insertBefore(buttonCell, toolBarRow.childNodes[0]);

        }
    }
    async function print(res) {
        if (dataUrl) {
            if (res.Message) {
                setLoaded(false);
                setErrorDialog(dispatch, res.Message, `چاپ اطلاعات [${reportName}]`);
                return;
            }
            setPending(true);
            report.load(res);
            await sleep(1000);

            /********************************* GET DATA ****************************/
            let result;
            if (method === "get") {
                result = await loadPrintDataSource_getAsync(dataUrl, serverUrl);
            }
            else if (method === "post") {
                let data = fetchBody;
                if (typeof data === 'object') {
                    data = JSON.stringify(data);
                }
                result = await loadPrintDataSource_postAsync(dataUrl, data, serverUrl);
            }
            /********************************* CHECK RESULT ********************************/
            if (!result || result.Message) {
                const msg = result?.Message ?? "";
                setErrorDialog(dispatch, msg, `چاپ اطلاعات [${reportName}]`);
                return;
            }
            setReportData(result);
        }
        else {
            if (res?.Message) {
                setLoaded(false);
                setErrorDialog(dispatch, res.Message, `چاپ اطلاعات [${modalData.title ?? ""}]`);
                return;
            }
            report.load(res);
            setReportData(jsonObject ?? {});
        }
    }
    const load = async (showPrint, repName) => {
        if (!showPrint || !repName) {
            return;
        }
        const result = await loadPrintReportAsync(repName, JSON.parse(designMode), serverUrl);
        await print(result);
    }
    useEffect(() => {
        load(show, reportName);

    }, [reportName, show])
    if (!show) {
        return null;
    }

    return (
        <Modal show={true} size="xl" onHide={() => { }}>
            <Modal.Header style={{ padding: loaded ? "1px" : "10px" }} className="headerStyle">
                {!loaded &&
                    <>
                        <span>
                            <FontAwesomeIcon icon={faPrint} size="lg" /> {modalData?.title ?? "چاپ"}
                        </span>
                        <span>
                            <FontAwesomeIcon icon={faTimes} size="lg" onClick={() => setModalData({ show: false })} />
                        </span></>}
            </Modal.Header>
            <Modal.Body style={{ minHeight: "95vh" }} className="bodyStyle">
                <div id="printDesigner" style={{ direction: "ltr" }}>
                    {pending &&
                        <Fragment>
                            <div>&nbsp;</div>
                            <div style={{ textAlign: "center" }}>
                                <Loader type="BallTriangle" color="#bb1370" height={40} width={40} />
                            </div>
                        </Fragment>
                    }
                </div>
            </Modal.Body>
        </Modal>
    )
}